const MODULE_ACCESS_BY_PATH = [
  ["/document-signature", "document_signature.access"],
  ["/consulta-processo", "process_consultation.access"],
  ["/advoc360", "advoc360.access"],
  ["/social-triggers", "social_triggers.access"],
  ["/flow-process", "flow_app.access"],
  ["/social-posts", "social_network.access"],
  ["/whatsapp-templates", "whatsapp_templates.access"],
  ["/meeting-rooms", "meeting_rooms.access"],
  ["/agendacare", "agenda_care.access"],
  ["/odontocare", "odonto_care.access"],
  ["/barber", "barber.access"],
  ["/petcare", "petcare.access"],
  ["/rotsa_360", "rotsa_360.access"],
  ["/service-appointments", "services.access"],
  ["/service-financial", "services.access"],
  ["/service-list", "services.access"],
  ["/service-messaging", "services.access"],
  ["/service-professionals", "services.access"],
  ["/service-queues", "services.access"],
  ["/services", "services.access"],
  ["/pdv", "pdv.access"],
  ["/loja-online", "pdv.access"],
  ["/comida-na-porta", "comida_na_porta.access"],
  ["/motoqueiro", "motoqueiro.access"],
  ["/woocommerce", "woocommerce.access"],
  ["/callcenter-central", "callcenter_central.access"],
  ["/callcenter", "callcenter.access"],
  ["/erpfone", "erp_phone.access"],
  ["/voip", "voip.access"],
  ["/asaas-financial", "asaas.access"],
  ["/bancario-cartoes", "banking_cards.access"],
  ["/kanban", "allowKanban"],
  ["/tags", "allowTags"],
  ["/tasks", "allowTasks"],
  ["/schedules", "allowSchedules"],
  ["/announcements", "allowAnnouncements"],
  ["/api", "allowApi"],
  ["/financeiro", "allowFinanceiro"]
].sort((first, second) => second[0].length - first[0].length);

export const getModuleAccessForPath = (path) => {
  const normalizedPath = String(path || "");
  const match = MODULE_ACCESS_BY_PATH.find(([prefix]) =>
    normalizedPath === prefix || normalizedPath.startsWith(`${prefix}/`)
  );

  return match?.[1] || null;
};

export const hasEffectiveModulePermission = (permissions, key, user) => {
  if (!key) return true;

  if (user?.super === true || user?.profile === "admin") {
    return true;
  }

  // Se key for uma flag simples (ex: allowKanban) no usuário
  if (user && Object.prototype.hasOwnProperty.call(user, key)) {
    const userVal = user[key];
    if (userVal === "disabled" || userVal === false) return false;
  }

  if (Array.isArray(permissions)) {
    const match = permissions.find((permission) => permission?.key === key);
    if (match) {
      return match.allowed === true;
    }
  }

  return true;
};
